import { Skeleton } from '@mui/material';

const NotifSkeleton = () => {
  return (
    <Skeleton
      animation="wave"
      variant="rectangular"
      width={400}
      height={200}
      sx={{ borderRadius: '16px' }}
    />
  );
};

export default NotifSkeleton;
